import { ReactNode } from 'react';
import { useLocation } from 'react-router-dom';
import { Header } from './Header';
import { Footer } from './Footer';
import { AnnouncementBanner } from './AnnouncementBanner';
import { StructuredData } from '@/components/seo/StructuredData';
import { HreflangTags } from '@/components/seo/HreflangTags';
import { LangAttributeSync } from '@/components/seo/LangAttributeSync';

interface LayoutProps {
  children: ReactNode;
}

export function Layout({ children }: LayoutProps) {
  const location = useLocation();
  const isHomePage = location.pathname === '/';

  return (
    <div className="min-h-screen flex flex-col">
      <StructuredData type="organization" />
      <StructuredData type="website" />
      <StructuredData type="localBusiness" />
      <HreflangTags />
      <LangAttributeSync />
      {isHomePage && <AnnouncementBanner />}
      <Header />
      <main className={`flex-1 ${isHomePage ? 'pt-[116px] md:pt-[164px]' : 'pt-[84px] md:pt-[132px]'}`}>
        {children}
      </main>
      <Footer />
    </div>
  );
}
